'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*global initialize*/

function K2Comments(containerID) {
  this.containerID = containerID;
  this.class = null;
  this.docNo = null;
  this.$container = null;

  this.init();
}

K2Comments.prototype = $.extend({}, {
  constructor: 'K2Comments',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('#' + _this.containerID).off('submit', 'form');
    $('#' + _this.containerID).on('submit', 'form', function () {
      _this.addComment($(this));
      return false;
    });

    $('#' + _this.containerID).off('click', '.reply');
    $('#' + _this.containerID).on('click', '.reply', function () {
      _this.replyComment($(this).closest('.comment'));
    });

    $('#' + _this.containerID).off('click', '.read');
    $('#' + _this.containerID).on('click', '.read', function () {
      _this.readComment($(this).closest('.comment'));
    });
  },

  readComment: function readComment($comment) {
    var $btn = $comment.find('.read');

    blockElement($comment);
    $.get(services.get('router').path('comment_read', { id: $comment.data('activity_id') }), function (res) {
      unBlockElement($comment);
      if (res.msg === 'SUCCESS') {
        $btn.fadeOut();
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });
  },

  replyComment: function replyComment($comment) {
    var _this = this;

    if (!$comment.next('form').length) {
      var $form = _this.$container.find('.comment-form').find('form').clone();
      $form.hide();
      $form.insertAfter($comment);
      $form.find('.superior-activity').val($comment.data('activity_id'));
      $form.slideDown('slow');
      initialize($form);

      $form.find('textarea').val('');
    }

    return _this;
  },

  addComment: function addComment($form) {
    var _this = this;

    blockElement($form);
    $.post($form.attr('action'), $form.serialize(), function (res) {
      unBlockElement($form);

      if (res.msg === 'SUCCESS') {
        _this.loadComments();
      } else if (res.msg === 'NOT_VALID') {
        $form.replaceWith(res.data.html);
        initialize($form);
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  loadComments: function loadComments() {
    var _this = this;

    blockElement(_this.$container);
    $.get(services.get('router').path('comments', { class: _this.class, docNo: _this.docNo }), function (res) {
      unBlockElement(_this.$container);
      _this.$container.html(res);
      initialize(_this.$container);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    var $loading = $('<div>', { class: 'comment-loading text-center' }).text(services.get('translator').trans('comment.loading'));

    _this.$container = $('#' + _this.containerID);
    _this.$container.append($loading);
    _this.class = _this.$container.data('class');
    _this.docNo = _this.$container.data('doc_no');
    _this.registerCallbacks();
    _this.loadComments();
  }
});
